import { createContext, useContext } from 'react'
import type { OfApi } from '../../ofApi'
import type { AlternativeMethod, PaymentCard, TabId, Transaction, WalletUser } from './cardsData'

/** What the page's parts share: OnlyFans, the loaded state and the page's actions. */
export interface CardsCtx {
  of: OfApi
  /** The referer onlyfans.com sends from the open tab. */
  referer: string
  canWrite: boolean
  mobile: boolean
  tab: TabId
  intl: string
  lang: string
  say: (text: string) => void
  me: WalletUser
  /** PATCH users/me {[field]: value} as OnlyFans' saveUserSetting; merges on success, throws on refusal. */
  saveSetting: (field: keyof WalletUser, value: boolean | number, toast?: boolean) => Promise<void>
  cards: PaymentCard[] | null
  setCards: (update: (all: PaymentCard[]) => PaymentCard[]) => void
  reloadCards: () => Promise<void>
  alternatives: AlternativeMethod[] | null
  setAlternatives: (update: (all: AlternativeMethod[]) => AlternativeMethod[]) => void
  /** alternative-payment-methods/paypal: canPay / canAdd. */
  paypal: string[]
  syncPaypal: () => Promise<void>
  mergeMe: (patch: Partial<WalletUser>) => void
  hasTransactions: boolean
  hasTransactionsLoading: boolean
  latest: Transaction[]
  latestLoading: boolean
  reloadLatest: () => Promise<void>
  openTab: (tab: TabId) => void
  onOpenPage: (page: string, query?: string) => void
}

export const CardsContext = createContext<CardsCtx | null>(null)

export function useCards(): CardsCtx {
  const ctx = useContext(CardsContext)
  if (!ctx) throw new Error('useCards outside CardsPage')
  return ctx
}
